import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import Box from '@material-ui/core/Box';

const SarasProgress = (props) => {
    const { value, progressScopeClass, progressClass, labelClass, progressType } = props;

    if(progressType === "circle"){
        return (
            <Box position="relative" display="inline-flex">
                <CircularProgress variant="determinate" color='' 
                    style={{position: 'absolute',left: 0}} 
                    value={100} 
                    className={progressScopeClass || "uiProgressScopeClass"}
                    />
                <CircularProgress variant="determinate" color='' 
                    value={value > 100 ? 100 : value} 
                    className={progressClass || "uiProgressClass"}
                    />
                <Box
                    top={0}
                    left={0}
                    bottom={0}
                    right={0}
                    position="absolute"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <span className={labelClass || "uiProgressLabelClass"}>{`${value}%`}</span>
                </Box>
            </Box>
        );
    }

    if(progressType === "bar"){
        return (
            <Box display="flex" alignItems="center">
              <Box width="100%" mr={1}>
                <LinearProgress variant="determinate" 
                    value={value > 100 ? 100 : value} 
                    color={progressClass}
                    className={progressClass || "uiProgressScopeClass"} />
              </Box>
              <Box minWidth={35}>
                  <span className={labelClass || "uiProgressLabelClass"}>{`${value}%`}</span>
              </Box>
            </Box>
          );
    }
}

export default SarasProgress;
